import { RidangoReduxAction } from '@ridango/core';

import momenttz from 'moment-timezone';

import { ValidationHistoryActions } from './validation-history.actions';

export const VALIDATION_HISTORY_STATE_KEY = 'validationHistory';

export interface ValidationHistoryState {
    validations: any[];
    loading: boolean;
    error: any;
    startDate: Date;
    endDate: Date;
    minStartDate: Date;
    minEndDate: Date;
    maxStartDate: Date;
    maxEndDate: Date;
    diff: number;
}

export const VALIDATION_HISTORY_INITIAL_STATE: ValidationHistoryState = {
    validations: [],
    loading: false,
    error: {},
    startDate: momenttz.tz('Europe/Tallinn').subtract(29, 'days').toDate(),
    endDate: momenttz.tz('Europe/Tallinn').toDate(),
    minStartDate: momenttz.tz('Europe/Tallinn').subtract(360, 'days').toDate(),
    minEndDate: momenttz.tz('Europe/Tallinn').subtract(360, 'days').toDate(),
    maxStartDate: momenttz.tz('Europe/Tallinn').toDate(),
    maxEndDate: momenttz.tz('Europe/Tallinn').toDate(),
    diff: 29,
};

export function validationHistoryReducer(
    state: ValidationHistoryState = VALIDATION_HISTORY_INITIAL_STATE,
    action: RidangoReduxAction
): ValidationHistoryState {
    switch (action.type) {
        case ValidationHistoryActions.FETCH_VALIDATION_HISTORY:
            return {
                ...state,
                loading: true,
            };
        case ValidationHistoryActions.FETCH_VALIDATION_HISTORY_SUCCESS:
            return {
                ...state,
                loading: false,
                validations: action.payload,
            };
        case ValidationHistoryActions.FETCH_VALIDATION_HISTORY_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case ValidationHistoryActions.SET_START_DATE:
            return {
                ...state,
                startDate: action.payload,
            };
        case ValidationHistoryActions.SET_END_DATE:
            return {
                ...state,
                endDate: action.payload,
            };
    }

    return state;
}

export interface ValidationHistoryPartialStoreState {
    [VALIDATION_HISTORY_STATE_KEY]: ValidationHistoryState;
}
